module.exports = __webpack_public_path__ + "static/32-d42f9aac3dad3e1a09b1e667d58461b5.png";